import { defineAction } from '~/prix'
import insightReadAction from './insightRead.action.json' assert { type: 'json' }
import { z } from 'zod'

const insightReadDefinition = defineAction({
  ...insightReadAction,
  input: z.object({
    id: z.string(),
  }),
  output: z.object({
    insight: z.any(),
  }),
  cache: () => {
    return {
      front: {
        // 5 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 5,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
    }
  },
})

export default insightReadDefinition
